var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-flex",
        [
          _c(
            "v-card",
            [
              _c(
                "v-container",
                _vm._b(
                  { attrs: { fluid: "" } },
                  "v-container",
                  { [`grid-list-${_vm.size}`]: true },
                  false
                ),
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "", xs12: "" } },
                    _vm._l(_vm.getActiveTypeCodes(), function (typecode) {
                      return _c(
                        "v-flex",
                        {
                          key: typecode.code,
                          attrs: { xs6: "", sm4: "", md2: "" },
                        },
                        [
                          _c("v-hover", {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ hover }) {
                                    return _c(
                                      "v-card",
                                      {
                                        class: `elevation-${hover ? 12 : 2}`,
                                        staticStyle: {
                                          height: "100%",
                                          cursor: "pointer",
                                        },
                                        attrs: {
                                          color: "var(--panel-background)",
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.setupNewSystem(typecode)
                                          },
                                        },
                                      },
                                      [
                                        _c("v-img", {
                                          attrs: { src: typecode.logo250 },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "v-card-title",
                                          {
                                            staticClass:
                                              "justify-center type-tile-title",
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getDescription(typecode)
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { wrap: "", xs12: "" } },
                    [
                      _c(
                        "v-flex",
                        {
                          staticStyle: {
                            border: "1px solid grey",
                            "font-size": "16px",
                            "font-weight": "600",
                          },
                        },
                        [
                          _vm._v(
                            "\n            Please contact your account team to use any of the following system types:\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { wrap: "", xs12: "" } },
                    _vm._l(_vm.getInactiveTypeCodes(), function (typecode) {
                      return _c(
                        "v-flex",
                        {
                          key: typecode.code,
                          attrs: { xs6: "", sm4: "", md2: "" },
                        },
                        [
                          _c(
                            "v-card",
                            {
                              staticStyle: {
                                height: "100%",
                                position: "relative",
                              },
                              attrs: { color: "var(--panel-background)" },
                            },
                            [
                              _c("v-img", {
                                staticStyle: {
                                  "-webkit-filter": "grayscale(100%)",
                                  filter: "grayscale(100%)",
                                },
                                attrs: { src: typecode.logo250 },
                              }),
                              _vm._v(" "),
                              _c(
                                "v-card-title",
                                {
                                  staticClass: "justify-center type-tile-title",
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.getDescription(typecode))
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }